import { render, staticRenderFns } from "./TextLoader.vue?vue&type=template&id=2166dc38&scoped=true&lang=pug"
import script from "./TextLoader.vue?vue&type=script&lang=js"
export * from "./TextLoader.vue?vue&type=script&lang=js"
import style0 from "./TextLoader.vue?vue&type=style&index=0&id=2166dc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166dc38",
  null
  
)

export default component.exports